import React from 'react';
import BaseLayout from 'Components/Layout/BaseLayout';
import PackageBanner from '../../Assets/Icons/PackageBanner.png';
import Breedcumb from 'Components/Breedcumb/Breedcumb';
import arIcon from '../../../src/Assets/pdf/annual-report.pdf';
import policy from '../../../src/Assets/pdf/policy.pdf';
import { Link } from 'react-router-dom';

function investorInfo() {

  return (
    <BaseLayout
      _class={
        'header-top-offset booking-process-header my-booking-details-page my-booking-main-page'
      }
    >
      <Breedcumb list={[{ text: 'Investor Information' }]} />
      <section className="investor-information-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="investor-information-wrapper">
                <Link
                  to={arIcon}
                  target="_blank"
                  className="btn btn-md"
                >
                  <span>Annual Report</span>
                </Link>
                <Link
                  to={policy}
                  target="_blank"
                  className="btn btn-reverse btn-md"
                >
                  <span>Annual Report</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </BaseLayout>
  );
}

export default investorInfo;
